import { createStore } from 'vuex'
import kvs from '@/store/kvs'
import integral from '@/store/integral'
import target from '@/store/target'
import createPersistedState from 'vuex-persistedstate'
import productionPlan from "@/store/productionPlan";
import durationSetting from "@/store/durationSetting";
import estimate from "@/store/estimate";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    kvs,
    integral,
    target,
    productionPlan,
    durationSetting,
    estimate
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
})
